<template>
    <library-main />
</template>

<script>
    export default {
        name: 'FormLibrary',
        beforeRouteLeave(to, from, next) {
            this.$loading();
            next();
        }
    };
</script>